import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import { fg } from '@atlaskit/platform-feature-flags';
import Textfield from '@atlaskit/textfield';
import { ShortTextFieldWrapper } from '../common/questionWrappers';
export var EditShortText = function EditShortText(_ref) {
  var id = _ref.id,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label;
  // Local state required to show textfield changes as onChange callback is debounced.
  // Without it, user will only see their last inputted character added within the debounce period.
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    textFieldValue = _useState2[0],
    setTextFieldValue = _useState2[1];
  useEffect(function () {
    if (fg('debounce_proforma_text_field_edits')) {
      setTextFieldValue(value);
    }
  }, [value]);
  var debouncedOnChange = useMemo(function () {
    return fg('debounce_proforma_text_field_edits') ? onChange ? debounce(onChange, 500) : noop : noop;
  }, [onChange]);
  var handleTextFieldChange = useCallback(function (e) {
    e.persist();
    setTextFieldValue(e.target.value);
    debouncedOnChange(e);
  }, [debouncedOnChange]);
  return /*#__PURE__*/React.createElement(ShortTextFieldWrapper, {
    isDisabled: false
  }, /*#__PURE__*/React.createElement(Textfield, {
    id: id,
    value: fg('debounce_proforma_text_field_edits') ? textFieldValue : value,
    isInvalid: isInvalid,
    onChange: fg('debounce_proforma_text_field_edits') ? handleTextFieldChange : onChange,
    width: "medium",
    label: label,
    "aria-label": label,
    title: label,
    placeholder: "",
    isRequired: isRequired
  }));
};